import { Component, Input, OnInit } from "@angular/core";
import { LoadingController, ModalController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Logger, LoggingService } from "ionic-logging-service";
import { RestolutionService } from "src/app/services/restolution";
import { CardPaymentService } from "../../services/cardpayment.service";
import { Receipt } from "../../types/receipt";

@Component({
  selector: "app-card-terminal-processing-modal",
  templateUrl: "./card-terminal-processing-modal.page.html",
  styleUrls: ["./card-terminal-processing-modal.page.scss"],
})
export class CardTerminalProcessingModalPage implements OnInit {
  @Input() receipt: Receipt;

  private message: string;
  private messageStream;
  private logger: Logger;

  constructor(private modalController: ModalController, private resto: RestolutionService, private cardPayment: CardPaymentService,
    private loadingCtrl: LoadingController, private translate: TranslateService, private loggingService: LoggingService) {
      this.logger = loggingService.getLogger("BestoGo.CardTerminalProcessingModal");
      loggingService.configure({
        ajaxAppender: {
          threshold: "INFO",
          url: this.resto.serverUrl + "rest/bestogo/" + this.resto.currentLogin.clientId + "/restaurant/" + this.resto.restoUuid + "/logs"
        }
      });
    }

  ngOnInit() {}

  doCancel() {
    this.cardPayment.abortPayment(this.receipt).subscribe(async (res) => {
      this.logger.info("doCancel", "Abort payment response: ", res);
    });
    this.modalController.dismiss({ msg: "Cancel" });
  }
}
